<template lang="pug">
    div.text-center
        v-dialog(v-model="dialog" width="500" persistent)
            v-card
                v-card-title(style="background-color: #ed1b24" dark class="text-h5 grey lighten-2") Informasi PJS
                v-card-text.pt-5 Anda terdaftar cuti di sistem SAP, silahkan atur PJS Anda!
                v-divider
                v-card-actions
                    v-spacer
                    v-btn(color="grey darken-1" text="" @click="closeModal()") Nanti
                    v-btn(dark="" color="#ed1b24" @click="setPjs()") Atur Sekarang
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'AlertPjsModal',
  data: () => ({
    dialog: true
  }),
  computed: {
    ...mapState(["modalNeedSetPjs"])
  },
  mounted: function(){
    this.dialog = this.modalNeedSetPjs;
  },
  methods: {
    closeModal() {
      this.dialog = false;
      this.$store.dispatch("closeNeedSetPjs");
    },
    setPjs(){
      this.closeModal();
      this.$router.push("/info-cuti");
    }
  }
};
</script>